<template>
    <div class="about">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-6">
                    <img :src="about.image" alt="">
                </div>
                <div class="col-12 col-md-6 about1">
                    <h2>{{about.title}}</h2>
                    <p class="pt-3">{{about.isi}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            about:Object
        }
    }
</script>

<style  scoped>
    .about {
        margin: 300px auto;
        color: #ffff;
    }
    .about1 p{
        color: #a4a4a4;
        font-size: .9rem;
    }
    /* Large Desktop */
    @media(min-width: 1025px){
        .about{
            width: 70rem;
        }
         .about1 h2, .about1 p{
            width: 26rem;
            margin-left: -100px;
        }
        .about1 h2{
            padding: unset;
        }
        .circle{
            padding: 15px 0;
        }
    }
    /* Desktop */
    @media(min-width:992px) and (max-width: 1024px){
        .about{
            width: 70rem;
        }
        .about1 h2, .about1 p{
            width: 26rem;
            margin-left: -100px;
        }
        .about1 h2{
            padding: unset;
        }
        .about1 p{
            padding: 15px 0;
        }
    }
    /* Tablet*/
    @media(min-width:768px) and (max-width: 991px){
        .about{
            width: unset;
        }
        .about1 h2, .about1 p{
            width: unset;
            margin-left: unset;
        }
        .about1 h2{
            padding: unset;
        }
        .about1 p{
            padding: 15px 0;
        }
    }
    /* Handphone */
    @media(max-width: 767px){
       .about{
        width: unset;
        text-align: center;
       }
       .about1 h2{
            padding: 15px 0;
        }
        .about1 h2, .about1 p{
            width: 100%; 
            text-align: center;  
            margin-left: unset;
        }
        .about1 p{
            padding: unset;
        }
    }
    
</style>